<div class="flex flex-col gap-6 w-full p-4">
    <h2 class="text-xl font-semibold text-center mt-4">
      {{ translateServ.dictionary['REL_TITLE'] || 'Relations Management' }}
    </h2>
    <p class="text-center text-gray-400">
      {{ translateServ.dictionary['REL_SUBTITLE'] || 'Define relations between Customers and Suppliers' }}
    </p>
  
    <p-toast></p-toast>
  
    <div class="card p-card-modern p-datatable-form">
      <p-table [value]="relations" [tableStyle]="{'min-width': '80rem'}">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 15%;">{{ translateServ.dictionary['REL_TIT_ENTITY'] || 'Entity' }}</th>
            <th style="width: 20%;">{{ translateServ.dictionary['REL_TIT_SELECT'] || 'Select Partner' }}</th>
            <th style="width: 15%;">{{ translateServ.dictionary['REL_TIT_SUPP_INNER'] || 'Supplier Inner Number' }}</th>
            <th style="width: 15%;">{{ translateServ.dictionary['REL_TIT_OUR_INNER'] || 'Our Inner Number' }}</th>
            <th style="width: 15%;">{{ translateServ.dictionary['REL_TIT_DESC'] || 'Description' }}</th>
            <th style="width: 10%;">{{ translateServ.dictionary['REL_TIT_ACTIVE'] || 'Active' }}</th>
            <th style="width: 10%;">{{ translateServ.dictionary['REL_TIT_APPROVED'] || 'Approved' }}</th>
            <th style="width: 5%;">{{ translateServ.dictionary['REL_TIT_ACTIONS'] || 'Actions' }}</th>
          </tr>
        </ng-template>
  
        <ng-template pTemplate="body" let-relation>
          <tr>
            <td class="text-center">
              <p-tag
                [value]="getNewEntityLabel()"
                severity="info">
              </p-tag>
            </td>
  
            <td>
              <p-autoComplete
                [(ngModel)]="relation.connectedPartner"
                [suggestions]="filteredPartners"
                (completeMethod)="searchPartners($event)"
                [field]="'label'"
                [dropdown]="true"
                [appendTo]="'body'"
                placeholder="{{ translateServ.dictionary['REL_SELECT_PARTNER'] || 'Select Partner' }}"
                (onSelect)="onConnectedEntitySelected($event)"
                [disabled]="!isCreate"
                styleClass="p-inputtext-sm w-full">
              </p-autoComplete>
            </td>
            <td>
              <input
                type="text"
                pInputText
                [(ngModel)]="relation.customer_supplier_number"
                placeholder="{{ translateServ.dictionary['REL_SUPP_INNER_PLACEHOLDER'] || 'Supplier Inner Number' }}"
                class="p-inputtext-sm w-full">
            </td>
  
            <td>
              <input
                type="text"
                pInputText
                [(ngModel)]="relation.innerNumber"
                placeholder="{{ translateServ.dictionary['REL_OUR_INNER_PLACEHOLDER'] || 'Our Inner Number' }}"
                class="p-inputtext-sm w-full">
            </td>
  
            <td>
              <input
                type="text"
                pInputText
                [(ngModel)]="relation.description"
                placeholder="{{ translateServ.dictionary['REL_DESC_PLACEHOLDER'] || 'Description' }}"
                class="p-inputtext-sm w-full">
            </td>
  
            <td class="text-center">
              <span (click)="toggleIsActive(relation)">
                <p-tag
                  [value]="relation.isActive === 1 ? (translateServ.dictionary['Active'] || 'Active') : (translateServ.dictionary['Inactive'] || 'Inactive')"
                  [severity]="getSeverity(relation.isActive === 1)">
                </p-tag>
              </span>
            </td>
  
            <td class="text-center">
              <span (click)="toggleIsApproved(relation)">
                <p-tag
                  [value]="relation.isApproved === 1 ? (translateServ.dictionary['Approved'] || 'Approved') : (translateServ.dictionary['Pending'] || 'Pending')"
                  [severity]="relation.isApproved === 1 ? 'success' : 'warning'">
                </p-tag>
              </span>
            </td>
  
            <td>
                <div class="flex gap-2">
                    <p-button
                        *ngIf="isCreate"
                        icon="pi pi-trash"
                        severity="danger"
                        styleClass="p-button-text p-button-sm"
                        (onClick)="removeEntry(relation)"
                        [label]="translateServ.dictionary['TOOLTIP_DELETE_ENTRY'] || 'Delete'">
                    </p-button>

                    <p-button
                        *ngIf="!isCreate"
                        icon="pi pi-check"
                        severity="info"
                        styleClass="p-button-text p-button-sm"
                        (onClick)="applyRowChanges(relation)"
                        [label]="translateServ.dictionary['APPLY_CHANGES'] || 'Apply Changes'">
                    </p-button>
                </div>
            </td>
          </tr>
        </ng-template>
  
        <ng-template pTemplate="footer" *ngIf="isCreate">
          <tr>
            <td class="text-center">
              <p-tag
                [value]="getNewEntityLabel()"
                severity="info">
              </p-tag>
            </td>
  
            <td>
              <p-autoComplete
                [(ngModel)]="newEntry.connectedPartner"
                [suggestions]="filteredPartners"
                (completeMethod)="searchPartners($event)"
                [field]="'label'"
                [dropdown]="true"
                [appendTo]="'body'"
                placeholder="{{ translateServ.dictionary['REL_SELECT_PARTNER'] || 'Select Partner' }}"
                (onSelect)="onConnectedEntitySelected($event)"
                styleClass="p-inputtext-sm w-full">
              </p-autoComplete>
            </td>
  
            <td>
              <input
                type="text"
                pInputText
                [(ngModel)]="newEntry.customer_supplier_number"
                placeholder="{{ translateServ.dictionary['REL_SUPP_INNER_PLACEHOLDER'] || 'Supplier Inner Number' }}"
                class="p-inputtext-sm w-full">
            </td>
  
            <td>
              <input
                type="text"
                pInputText
                [(ngModel)]="newEntry.innerNumber"
                placeholder="{{ translateServ.dictionary['REL_OUR_INNER_PLACEHOLDER'] || 'Our Inner Number' }}"
                class="p-inputtext-sm w-full">
            </td>
  
            <td>
              <input
                type="text"
                pInputText
                [(ngModel)]="newEntry.description"
                placeholder="{{ translateServ.dictionary['REL_DESC_PLACEHOLDER'] || 'Description' }}"
                class="p-inputtext-sm w-full">
            </td>
  
            <td class="text-center">
              <span (click)="toggleIsActive(newEntry)">
                <p-tag
                  [value]="newEntry.isActive === 1 ? 'Active' : 'Inactive'"
                  [severity]="getSeverity(newEntry.isActive === 1)">
                </p-tag>
              </span>
            </td>
  
            <td class="text-center">
              <span (click)="toggleIsApproved(newEntry)">
                <p-tag
                  [value]="newEntry.isApproved === 1 ? 'Approved' : 'Pending'"
                  [severity]="newEntry.isApproved === 1 ? 'success' : 'warning'">
                </p-tag>
              </span>
            </td>
  
            <td>
              <p-button
                [label]="translateServ.dictionary['ADD'] || 'Add'"
                icon="pi pi-plus"
                severity="success"
                styleClass="p-button-text p-button-sm"
                (onClick)="addEntry()">
              </p-button>
            </td>
          </tr>
        </ng-template>
  
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" class="text-center text-gray-500">
              {{ translateServ.dictionary['REL_EMPTY_MSG'] || 'No relations found' }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  
    <div class="flex justify-between pt-6">
        <ng-container *ngIf="!isDialogMode">
            <p-button
                [label]="translateServ.dictionary['BACK']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-right' : 'pi pi-arrow-left'"
                [iconPos]="dirServ.isRtl() ? 'right' : 'left'"
                severity="secondary"
                (onClick)="goToPreviousStep()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['NEXT']"
                [icon]="dirServ.isRtl() ? 'pi pi-arrow-left' : 'pi pi-arrow-right'"
                [iconPos]="dirServ.isRtl() ? 'left' : 'right'"
                (onClick)="validateAndProceed()">
            </p-button>
        </ng-container>
        <ng-container *ngIf="isDialogMode">
            <p-button
                [label]="translateServ.dictionary['CANCEL'] || 'Cancel'"
                [icon]="'pi pi-times'"
                severity="secondary"
                (onClick)="closeDialog()">
            </p-button>
            <p-button
                [label]="translateServ.dictionary['SAVE'] || 'Save'"
                [icon]="'pi pi-save'"
                (onClick)="saveAndSubmit()"
                [disabled]="relations.length === 0">
            </p-button>
        </ng-container>
    </div>
</div>